import React, { useEffect } from 'react'
import { onClientSide } from 'utils/utils'
import useModal from '@/modern/actions/useModal'
import ModalContainer from '@/modern/components/ModalContainer'
import Loading from '../Loading'
import * as S from '../style'

function ModalLoading() {
  const { closeModal, modal } = useModal('promoBlackFairLoadingModal')

  function handleCloseModal(event) {
    if (!onClientSide()) return
    if (event) {
      event.stopPropagation()
    }
    closeModal()
  }

  useEffect(() => {
    if (onClientSide()) {
      if (modal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
      return () => {
        document.body.style.overflow = ''
      }
    }
  }, [modal])

    return (
      <ModalContainer
        align="center"
        show={modal}
        useWhiteBox
        onBgClick={e => handleCloseModal(e)}
      >
        <S.Wrapper>
          <S.CloseButton onClick={e => handleCloseModal(e)}>
            <S.CloseIcon name="Close_1" fill="#2E2E37" size="24" />
          </S.CloseButton>
          <S.SpinnerContainer>
            <Loading />
          </S.SpinnerContainer>
        </S.Wrapper>
      </ModalContainer>
    )
}

export default ModalLoading
